import styled from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const FilterItemWrapper = styled.section`
    display: flex;
    flex-direction: column;
    background-color: ${getPurpurColor('brandWhite')};
`;
type FilterItemExpandButtonProps = {
    $isExpanded: boolean;
};

export const FilterItemExpandButton = styled.button<FilterItemExpandButtonProps>`
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: ${getPurpurSpacing('300')};
    background-color: ${({ $isExpanded }) => ($isExpanded ? getPurpurColor('brandWhite') : getPurpurColor('gray50'))};

    ${purpurFocus('-0.125rem')};
`;

export const FacetItemTitle = styled.span`
    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${getPurpurTypography('weightBold')};
    color: ${getPurpurColor('textDefault')};
    text-align: left;
`;
